import type { HttpResponse } from "./types.js";

// Raw regex-alternation fragment, not a plain string: callers splice it into a
// `new RegExp()`. Phrases must stay metacharacter-free or the built regex shifts.
export const CF_TITLE_PHRASES = "Just a moment|Chờ một chút";
const CF_TITLE_REGEX = new RegExp(`<title>(?:${CF_TITLE_PHRASES})\\b`, "i");
const CF_BODY_MARKER = /cf-browser-verification|cdn-cgi\/challenge-platform/;
// Cloudflare serves challenge pages on 403 (block), 503 ("Under Attack"),
// 429 (rate-gate), and occasionally 200 (Turnstile interstitial). The body /
// header markers below still gate the decision; status alone is not enough.
const CF_CANDIDATE_STATUSES = new Set([200, 403, 429, 503]);

export function isCloudflareChallenge(res: HttpResponse): boolean {
  if (!CF_CANDIDATE_STATUSES.has(res.status)) return false;
  if (res.headers["cf-mitigated"] === "challenge") return true;
  if (CF_TITLE_REGEX.test(res.body)) return true;
  if (CF_BODY_MARKER.test(res.body)) return true;
  return false;
}
